import CustomPalette from "./CustomPaletteProvider";

const o = {
 __init__: ["customPalette"],
 customPalette: ["type", CustomPalette],
};

export default o;
